'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationErrors = exports.EditableLegalConsentKeys = exports.SettingsKeys = exports.LegalConsentKeys = exports.ProcessingConsentTypes = exports.CamelCaseOptions = exports.LegalConsentOptions = exports.LEGAL_CONSENT_SUBMISSION_SUBSCRIPTION_PREFIX_KEY = exports.LEGAL_CONSENT_SUBMISSION_PROCESSING_KEY = exports.LEGAL_CONSENT_VALUES_KEY = exports.LEGAL_CONSENT_OPTIONS_KEY = undefined;

var _Object$freeze;

var _reactUtils = require('react-utils');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LEGAL_CONSENT_OPTIONS_KEY = exports.LEGAL_CONSENT_OPTIONS_KEY = 'legalConsentOptions';
var LEGAL_CONSENT_VALUES_KEY = exports.LEGAL_CONSENT_VALUES_KEY = 'legalConsentValues';

var LEGAL_CONSENT_SUBMISSION_PROCESSING_KEY = exports.LEGAL_CONSENT_SUBMISSION_PROCESSING_KEY = 'processing';
var LEGAL_CONSENT_SUBMISSION_SUBSCRIPTION_PREFIX_KEY = exports.LEGAL_CONSENT_SUBMISSION_SUBSCRIPTION_PREFIX_KEY = 'subscription_type_';

var LegalConsentOptions = exports.LegalConsentOptions = (0, _reactUtils.keyMirror)({
  NONE: null,
  IMPLICIT_CONSENT: null,
  SEPERATE_CONSENT: null,
  LEGITIMATE_INTEREST: null
});

var CamelCaseOptions = exports.CamelCaseOptions = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, LegalConsentOptions.NONE, 'none'), _defineProperty(_Object$freeze, LegalConsentOptions.IMPLICIT_CONSENT, 'implicitConsent'), _defineProperty(_Object$freeze, LegalConsentOptions.SEPERATE_CONSENT, 'seperateConsent'), _defineProperty(_Object$freeze, LegalConsentOptions.LEGITIMATE_INTEREST, 'legitimateInterest'), _Object$freeze));

var ProcessingConsentTypes = exports.ProcessingConsentTypes = (0, _reactUtils.keyMirror)({
  IMPLICIT: null,
  REQUIRED_CHECKBOX: null
});

var LegalConsentKeys = exports.LegalConsentKeys = Object.freeze({
  IS_LEGITIMATE_INTEREST: 'isLegitimateInterest',
  COMMUNICATION_CONSENT_TEXT: 'communicationConsentText',
  COMMUNICATION_CONSENT_CHECKBOXES: 'communicationConsentCheckboxes',
  PROCESSING_CONSENT_TYPE: 'processingConsentType',
  PROCESSING_CONSENT_TEXT: 'processingConsentText',
  PROCESSING_CONSENT_CHECKBOX_LABEL: 'processingConsentCheckboxLabel',
  PROCESSING_CONSENT_FOOTER_TEXT: 'processingConsentFooterText',
  PRIVACY_POLICY_TEXT: 'privacyPolicyText',
  SUBSCRIPTION_TYPES: 'legitimateInterestSubscriptionTypes',
  LAWFUL_BASIS: 'legitimateInterestLegalBasis'
});

var SettingsKeys = exports.SettingsKeys = Object.freeze({
  COMMUNICATION_CONSENT_CHECKBOXES: 'communicationConsentCheckboxes',
  COMMUNICATION_CONSENT_TEXT: 'communicationConsentText',
  EXPLICIT_PROCESSING_CONSENT_CHECKBOX_LABEL: 'explicitProcessingConsentCheckboxLabel',
  EXPLICIT_PROCESSING_CONSENT_TEXT: 'explicitProcessingConsentText',
  IMPLICIT_PROCESSING_CONSENT_TEXT: 'implicitProcessingConsentText',
  LEGITIMATE_INTEREST_PRIVACY_POLICY_TEXT: 'legitimateInterestPrivacyPolicyText',
  PRIVACY_POLICY_TEXT: 'privacyPolicyText'
});

var EditableLegalConsentKeys = exports.EditableLegalConsentKeys = Object.freeze({
  COMMUNICATION_CONSENT_TEXT: LegalConsentKeys.COMMUNICATION_CONSENT_TEXT,
  COMMUNICATION_CONSENT_CHECKBOXES: LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES,
  PROCESSING_CONSENT_TEXT: LegalConsentKeys.PROCESSING_CONSENT_TEXT,
  PROCESSING_CONSENT_CHECKBOX_LABEL: LegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL,
  PROCESSING_CONSENT_FOOTER_TEXT: LegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT,
  SUBSCRIPTION_TYPES: LegalConsentKeys.SUBSCRIPTION_TYPES,
  LAWFUL_BASIS: LegalConsentKeys.LAWFUL_BASIS,
  PRIVACY_POLICY_TEXT: LegalConsentKeys.PRIVACY_POLICY_TEXT
});

var ValidationErrors = exports.ValidationErrors = Object.freeze({
  REQUIRED: 'required'
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/FormsCommonComponents/static-1.726/js/constants/LegalConsent.js
// module id = 234
// module chunks = 0